/* GALLANTI theme.js — vanilla, native Shopify AJAX cart + PDP variants */
(function () {
  "use strict";

  /* ---------------- money ---------------- */
  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* ---------------- toast ---------------- */
  function ensureToastStack() {
    var s = document.getElementById("ToastStack");
    if (!s) {
      s = document.createElement("div");
      s.id = "ToastStack";
      document.body.appendChild(s);
    }
    return s;
  }
  function toast(title, desc) {
    var stack = ensureToastStack();
    var t = document.createElement("div");
    t.className = "toast";
    t.innerHTML = "<b></b><span></span>";
    t.querySelector("b").textContent = title || "";
    t.querySelector("span").textContent = desc || "";
    stack.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  }
  window.gallantiToast = toast;

  /* ---------------- cart drawer ---------------- */
  var overlay, drawer;

  function openCart() {
    if (overlay) overlay.setAttribute("data-open", "true");
    if (drawer) drawer.setAttribute("data-open", "true");
  }
  function closeCart() {
    if (overlay) overlay.setAttribute("data-open", "false");
    if (drawer) drawer.setAttribute("data-open", "false");
  }

  function renderCart(cart) {
    // count badges
    var counts = document.querySelectorAll("[data-cart-count]");
    counts.forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute("hidden");
      else el.setAttribute("hidden", "");
    });

    // status bar item count
    var statusCount = document.querySelector("[data-cart-status-count]");
    if (statusCount) statusCount.textContent = cart.item_count + " item(s)";

    var linesEl = document.querySelector("[data-cart-lines]");
    var footEl = document.querySelector("[data-cart-foot]");
    if (!linesEl) return;

    if (!cart.items || cart.items.length === 0) {
      linesEl.innerHTML =
        '<div class="cart-empty"><div>' +
        '<div class="font-pixel text-dim" style="margin-bottom:12px">// empty //</div>' +
        '<p style="margin-bottom:16px">your cart is a blank document.</p>' +
        '<button class="pixel-btn" data-cart-close>continue browsing</button>' +
        "</div></div>";
      if (footEl) footEl.style.display = "none";
      return;
    }

    var html = "";
    cart.items.forEach(function (item) {
      var variant = item.variant_title && item.variant_title !== "Default Title"
        ? '<p class="cart-line__variant">' + esc(item.variant_title) + "</p>"
        : "";
      var img = item.image
        ? '<img src="' + item.image + '" alt="' + esc(item.product_title) + '">'
        : "";
      html +=
        '<div class="cart-line bevel-out">' +
          '<div class="cart-line__img bevel-in">' + img + "</div>" +
          '<div class="cart-line__body">' +
            '<div class="cart-line__top">' +
              "<div style=\"min-width:0\">" +
                '<h4 class="cart-line__name">' + esc(item.product_title) + "</h4>" +
                variant +
              "</div>" +
              '<button class="cart-line__remove bevel-out" data-line-remove="' + item.key + '" aria-label="remove">✕</button>' +
            "</div>" +
            '<div class="cart-line__bottom">' +
              '<div class="qty bevel-in">' +
                '<button data-line-key="' + item.key + '" data-line-qty="' + (item.quantity - 1) + '" aria-label="decrease">−</button>' +
                "<span>" + item.quantity + "</span>" +
                '<button data-line-key="' + item.key + '" data-line-qty="' + (item.quantity + 1) + '" aria-label="increase">+</button>' +
              "</div>" +
              '<span class="font-display">' + money(item.line_price) + "</span>" +
            "</div>" +
          "</div>" +
        "</div>";
    });
    linesEl.innerHTML = html;

    if (footEl) {
      footEl.style.display = "block";
      var totalEl = footEl.querySelector("[data-cart-total]");
      if (totalEl) totalEl.textContent = money(cart.total_price);
    }
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return getCart().then(renderCart);
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "could not add"); });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(function () { openCart(); })
      .catch(function (err) { toast("error", err.message || "could not add to cart"); });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { toast("error", "could not update cart"); });
  }

  /* ---------------- global delegated handlers ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-cart-open]");
    if (t) { e.preventDefault(); openCart(); return; }

    if (e.target.closest("[data-cart-close]")) { e.preventDefault(); closeCart(); return; }

    var add = e.target.closest("[data-add-to-cart]");
    if (add) {
      e.preventDefault();
      var vid = add.getAttribute("data-variant-id");
      if (!vid) { toast("unavailable", "select options first"); return; }
      var qtyInput = document.querySelector("[data-qty-input]");
      var q = add.hasAttribute("data-use-qty") && qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(vid, q);
      return;
    }

    var rm = e.target.closest("[data-line-remove]");
    if (rm) { e.preventDefault(); changeLine(rm.getAttribute("data-line-remove"), 0); return; }

    var qbtn = e.target.closest("[data-line-key]");
    if (qbtn) { e.preventDefault(); changeLine(qbtn.getAttribute("data-line-key"), parseInt(qbtn.getAttribute("data-line-qty"), 10)); return; }

    if (e.target.closest("[data-checkout]")) { e.preventDefault(); window.location.href = "/checkout"; return; }
  });

  /* ---------------- PDP variant logic ---------------- */
  function initPDP() {
    var root = document.querySelector("[data-pdp]");
    var jsonEl = document.getElementById("ProductJson");
    if (!root || !jsonEl) return;

    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var selected = {};
    // seed from first available variant, else first variant
    var firstVariant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    if (!firstVariant) return;
    (product.options || []).forEach(function (name, i) { selected[name] = firstVariant.options[i]; });

    var addBtn = root.querySelector("[data-add-to-cart]");
    var priceEl = root.querySelector("[data-pdp-price]");
    var statusEl = root.querySelector("[data-pdp-status]");

    function findVariant() {
      return product.variants.find(function (v) {
        return product.options.every(function (name, i) { return v.options[i] === selected[name]; });
      });
    }

    function update() {
      var v = findVariant();
      root.querySelectorAll("[data-opt-btn]").forEach(function (b) {
        var on = selected[b.getAttribute("data-opt-name")] === b.getAttribute("data-opt-value");
        b.classList.toggle("is-selected", on);
      });
      if (v) {
        if (priceEl) priceEl.textContent = money(v.price);
        if (addBtn) {
          addBtn.setAttribute("data-variant-id", v.id);
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? "▶ add to cart" : "✕ sold out";
        }
        if (statusEl) statusEl.textContent = v.available ? "in stock" : "sold out";
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = "✕ unavailable"; }
        if (statusEl) statusEl.textContent = "unavailable";
      }
    }

    root.addEventListener("click", function (e) {
      var b = e.target.closest("[data-opt-btn]");
      if (!b) return;
      e.preventDefault();
      selected[b.getAttribute("data-opt-name")] = b.getAttribute("data-opt-value");
      update();
    });

    // gallery thumbs
    var mainImg = root.querySelector("[data-pdp-main-img]");
    var statusImg = root.querySelector("[data-pdp-img-count]");
    root.querySelectorAll("[data-pdp-thumb]").forEach(function (thumb, i) {
      thumb.addEventListener("click", function () {
        if (mainImg) mainImg.src = thumb.getAttribute("data-full");
        root.querySelectorAll("[data-pdp-thumb]").forEach(function (t) { t.classList.remove("bevel-in"); t.classList.add("bevel-out"); });
        thumb.classList.add("bevel-in"); thumb.classList.remove("bevel-out");
        if (statusImg) statusImg.textContent = (i + 1);
      });
    });

    // qty stepper
    var qtyInput = root.querySelector("[data-qty-input]");
    root.addEventListener("click", function (e) {
      var dec = e.target.closest("[data-qty-dec]");
      var inc = e.target.closest("[data-qty-inc]");
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      if (dec) qtyInput.value = Math.max(1, val - 1);
      if (inc) qtyInput.value = val + 1;
    });

    update();
  }

  /* ---------------- boot ---------------- */
  document.addEventListener("DOMContentLoaded", function () {
    overlay = document.querySelector("[data-cart-overlay]");
    drawer = document.querySelector("[data-cart-drawer]");
    initPDP();
    refreshCart();
  });
})();
